import type { ExtractionRun, MoodleDocument } from "../api/types";

// Extraction runs don't record which documents they wrote (API gap), so we
// infer it. Each run is one DB transaction and `extracted_at` is a server
// default of now() — Postgres' TRANSACTION start time — so a document's
// extracted_at is at or just before its run's started_at. Each document goes
// to the earliest run that started at/after its timestamp, provided it's
// within MAX_LEAD_MS of that start and not after the run finished.
//
// Only documents still live are returned: re-extracting a module replaces its
// documents, so older runs keep their documents_written count but show fewer
// current documents here.

const TOLERANCE_MS = 1; // API timestamps are µs; JS Dates truncate to ms
const MAX_LEAD_MS = 2000;

export function attributeDocuments(runs: ExtractionRun[], docs: MoodleDocument[]) {
  const sorted = runs
    .filter((r) => r.started_at)
    .map((r) => ({
      id: r.id,
      start: new Date(r.started_at!).getTime(),
      end: r.finished_at ? new Date(r.finished_at).getTime() : Infinity,
    }))
    .sort((a, b) => a.start - b.start);

  const byRun = new Map<number, MoodleDocument[]>();
  for (const r of sorted) byRun.set(r.id, []);

  for (const doc of docs) {
    if (!doc.extracted_at) continue;
    const t = new Date(doc.extracted_at).getTime();
    const run = sorted.find((r) => r.start >= t - TOLERANCE_MS);
    if (run && run.start - t <= MAX_LEAD_MS && t <= run.end + TOLERANCE_MS) {
      byRun.get(run.id)!.push(doc);
    }
  }
  return byRun;
}
